/**
 * SearchBar Component
 *
 * Reusable search bar component with consistent styling.
 * Used in the TopBar and other pages that need search functionality.
 */

import React from 'react';
import { SearchIcon } from '../icons';
import { Box, InputBase } from '../ui';

interface SearchBarProps {
  value: any;
  onChange: any;
  onKeyDown?: any;
  placeholder?: string;
  sx?: any;
  [key: string]: any;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onKeyDown, placeholder = 'Search', sx, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'background.lightGray',
        borderRadius: 2,
        px: 2,
        py: 0.5,
        ...sx,
      }}
      {...props}
    >
      <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
      <InputBase placeholder={placeholder} sx={{ width: '100%', color: 'text.primary' }} value={value} onKeyDown={onKeyDown} onChange={onChange} />
    </Box>
  );
};

export default SearchBar;
